import IqosNova from './IqosNova';
export default IqosNova;
